var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#916ede",
    d: "M256 22C120.69 22 11 131.69 11 267c0 71.09 30.289 135.096 78.653 179.85l1-.438v-21.394a4.51 4.51 0 0 1 4.505-4.505h119.644a4.51 4.51 0 0 1 4.505 4.505v83.226l1 1.159A246.972 246.972 0 0 0 256 512c135.31 0 245-109.69 245-245S391.31 22 256 22z",
    opacity: 1,
    "data-original": "#8ac9fe",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M301.89 3v43l2.391 1h44.054l2.504-1V3a3 3 0 0 0-3-3H304.89a3 3 0 0 0-3 3z",
    opacity: 1,
    "data-original": "#cecece",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M322.051 3a3 3 0 0 1 3-3H304.89a3 3 0 0 0-3 3v43h20.161z",
    opacity: 1,
    "data-original": "#bfbfbf",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f6f6",
    d: "M301.89 46h48.949v94H301.89z",
    opacity: 1,
    "data-original": "#f8f6f6",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e2",
    d: "M301.89 46h20.161v94H301.89z",
    opacity: 1,
    "data-original": "#e2e2e2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe646f",
    d: "m88.029 42.377-16.257 28.16C63.441 84.965 73.854 103 90.514 103s27.073-18.035 18.743-32.463l-16.258-28.16c-1.104-1.913-3.865-1.913-4.97 0z",
    opacity: 1,
    "data-original": "#fe646f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd4755",
    d: "m87.932 70.537 10.663-18.468L93 42.378c-1.104-1.913-3.866-1.913-4.97 0L71.772 70.537C63.441 84.965 73.854 103 90.514 103c2.908 0 5.619-.56 8.08-1.543-11.637-4.653-17.538-19.01-10.662-30.92z",
    opacity: 1,
    "data-original": "#fd4755"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a4",
    d: "M200.803 333.754v-43.063h-31.916v-15.367a7.684 7.684 0 0 0-7.684-7.684H81.909c-12.731 0-23.051 10.32-23.051 23.051v61.994a38.418 38.418 0 0 0 11.073 26.985l23.955 24.275a38.4 38.4 0 0 1 9.623 16.57H206.5a38.393 38.393 0 0 1 9.795-16.609l6.532-6.511c-13.79-17.542-22.024-39.648-22.024-63.641z",
    opacity: 1,
    "data-original": "#fed2a4",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a4",
    d: "M200.803 191.67c-4.222-5.339-10.751-8.768-18.086-8.768-12.731 0-23.051 10.32-23.051 23.051v-8.816c0-12.731-10.32-23.051-23.051-23.051-12.73 0-23.051 10.32-23.051 23.051v-59.505c0-12.731-10.32-23.051-23.051-23.051-12.731 0-23.051 10.32-23.051 23.051v136.421c3.873-3.367 8.923-5.412 14.445-5.412h79.294a6.691 6.691 0 0 1 6.684 6.684v16.343c0 4.252-1.276 8.207-3.45 11.522 4.214 5.481 10.833 9.016 18.281 9.016 7.335 0 13.864-3.43 18.086-8.768V191.67z",
    opacity: 1,
    "data-original": "#fed2a4",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd86",
    d: "M136.389 267.64v-70.504c0-8.574 4.692-16.04 11.638-20.01a22.914 22.914 0 0 0-11.412-3.04c-12.731 0-23.051 10.32-23.051 23.051v70.504h22.825z",
    opacity: 1,
    "data-original": "#ffbd86",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffbd86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.632 289.154v-83.202c0-8.545 4.661-15.986 11.568-19.968a22.916 22.916 0 0 0-11.483-3.083c-12.731 0-23.051 10.32-23.051 23.051v61.688h1.537a7.683 7.683 0 0 1 7.683 7.684v16.343c0 4.577-1.394 8.829-3.779 12.355 4.228 5.003 10.546 8.183 17.609 8.183 4.186 0 8.099-1.133 11.483-3.083-6.906-3.981-11.567-11.423-11.567-19.968zM81.909 267.64h8.238V137.631c0-8.604 4.723-16.093 11.709-20.053a22.926 22.926 0 0 0-11.342-2.997c-12.731 0-23.051 10.32-23.051 23.05v135.102a22.958 22.958 0 0 1 14.446-5.093z",
    fill: "#ffbd86",
    opacity: 1,
    "data-original": "#ffbd86",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fe646f",
    d: "M214.801 419.514H95.158a5.505 5.505 0 0 0-5.505 5.505v21.832c35.441 32.796 80.587 55.244 130.654 62.553v-84.385a5.506 5.506 0 0 0-5.506-5.505z",
    opacity: 1,
    "data-original": "#fe646f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd4755",
    d: "M89.653 425.019v21.832a245.82 245.82 0 0 0 43.375 32.086v-53.918a5.505 5.505 0 0 1 5.505-5.505H95.158a5.504 5.504 0 0 0-5.505 5.505z",
    opacity: 1,
    "data-original": "#fd4755"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.514,
    cy: 139.034,
    r: 8.808,
    fill: "#fd4755",
    opacity: 1,
    "data-original": "#fd4755"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5c2",
    d: "M161.203 267.64H81.909c-12.731 0-23.051 10.32-23.051 23.051v61.993a38.418 38.418 0 0 0 11.073 26.985l23.955 24.275h9.388c24.073 0 43.582-19.075 43.536-43.158-.027-14.027-7.901-26.871-20.145-33.713l-23.858-13.331h44.003c12.192 0 22.075-9.883 22.075-22.075V275.325a7.68 7.68 0 0 0-7.682-7.685z",
    opacity: 1,
    "data-original": "#ffe5c2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9c9c",
    d: "M348.779 437.9h-44.83c-57.518 0-104.146-46.628-104.146-104.146v-142.68c0-28.759 23.314-52.073 52.073-52.073h148.976c28.759 0 52.073 23.314 52.073 52.073v142.68c.001 57.518-46.627 104.146-104.146 104.146z",
    opacity: 1,
    "data-original": "#9c9c9c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M225.84 333.754v-142.68c0-14.357 11.68-26.037 26.037-26.037h17.108C277.99 149.477 294.803 139 314.074 139h-62.197c-28.759 0-52.073 23.314-52.073 52.073v142.681c0 57.518 46.628 104.146 104.146 104.146h44.83c2.925 0 5.82-.127 8.684-.363-23.171-1.913-44.188-11.414-60.568-26.007-39.776-3.58-71.056-37.086-71.056-77.776z",
    opacity: 1,
    "data-original": "#838383",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M303.949 411.863c-43.07 0-78.11-35.04-78.11-78.11v-142.68c0-14.357 11.68-26.037 26.037-26.037h148.976c14.357 0 26.037 11.68 26.037 26.037v142.68c0 43.07-35.04 78.11-78.11 78.11z",
    opacity: 1,
    "data-original": "#cecece",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M277.951 333.754v-13.205h-20.867c-5.752 0-10.415-4.663-10.415-10.415V207.315c0-5.752 4.663-10.415 10.415-10.415h20.867v-5.827c0-14.357 11.68-26.036 26.037-26.036h-52.111c-14.357 0-26.037 11.68-26.037 26.036v142.681c0 43.07 35.04 78.11 78.11 78.11h44.83c1.221 0 2.433-.037 3.641-.092-41.386-1.91-74.47-36.17-74.47-78.018z",
    opacity: 1,
    "data-original": "#bfbfbf",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe646f",
    d: "M282.102 379.607h-3.124c-11.504 0-20.829-9.326-20.829-20.829 0-11.504 9.326-20.829 20.829-20.829h3.124c11.504 0 20.829 9.326 20.829 20.829 0 11.504-9.325 20.829-20.829 20.829z",
    opacity: 1,
    "data-original": "#fe646f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd4755",
    d: "M279 358.778c0-8.329 4.901-15.496 11.966-18.828a20.712 20.712 0 0 0-8.864-2.001h-3.124c-11.504 0-20.829 9.326-20.829 20.829 0 11.504 9.326 20.829 20.829 20.829h3.124c3.174 0 6.171-.731 8.864-2.001-7.065-3.332-11.966-10.499-11.966-18.828z",
    opacity: 1,
    "data-original": "#fd4755"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26a6fe",
    d: "M373.751 379.607h-3.124c-11.504 0-20.829-9.326-20.829-20.829 0-11.504 9.326-20.829 20.829-20.829h3.124c11.504 0 20.829 9.326 20.829 20.829 0 11.504-9.325 20.829-20.829 20.829z",
    opacity: 1,
    "data-original": "#26a6fe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0593fc",
    d: "M370.217 358.778c0-8.415 5-15.646 12.182-18.932a20.715 20.715 0 0 0-8.648-1.897h-3.124c-11.504 0-20.829 9.326-20.829 20.829 0 11.504 9.326 20.829 20.829 20.829h3.124a20.73 20.73 0 0 0 8.648-1.897c-7.182-3.286-12.182-10.517-12.182-18.932z",
    opacity: 1,
    "data-original": "#0593fc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M395.645 320.549H257.083c-5.752 0-10.415-4.663-10.415-10.415V207.315c0-5.752 4.663-10.415 10.415-10.415h138.562c5.752 0 10.415 4.663 10.415 10.415v102.819c0 5.752-4.663 10.415-10.415 10.415z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaf6ff",
    d: "M288.412 310.134V207.315c0-5.752 4.663-10.415 10.415-10.415h-41.743c-5.752 0-10.415 4.663-10.415 10.415v102.819c0 5.752 4.663 10.415 10.415 10.415h41.743c-5.752 0-10.415-4.663-10.415-10.415z",
    opacity: 1,
    "data-original": "#eaf6ff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.364,
    cy: 303.4,
    r: 7.5,
    fill: "#26a6fe",
    opacity: 1,
    "data-original": "#26a6fe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.364,
    cy: 303.4,
    r: 7.5,
    fill: "#26a6fe",
    opacity: 1,
    "data-original": "#26a6fe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.364,
    cy: 282.4,
    r: 7.5,
    fill: "#fd4755",
    opacity: 1,
    "data-original": "#fd4755"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#916ede",
    d: "M311.913 222.4h-14.825c-6.86 0-12.441 5.581-12.441 12.441v18.117c0 6.86 5.581 12.441 12.441 12.441h12.265v13h-15.01a7.5 7.5 0 0 0 0 15h17.568c6.86 0 12.441-5.581 12.441-12.441V234.84c.001-6.859-5.58-12.44-12.439-12.44zm-2.56 28h-9.706v-13h9.706zM355.64 293.4h-14.825c-6.859 0-12.44-5.581-12.44-12.44v-46.119c0-6.86 5.581-12.441 12.441-12.441h14.823c6.86 0 12.441 5.581 12.441 12.441v46.118c.002 6.86-5.58 12.441-12.44 12.441zm-12.265-15h9.706v-41h-9.706z",
    opacity: 1,
    "data-original": "#0172fb",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrbs);
export default __webpack_public_path__ + "static/media/grbs.246c44f8c2e93338d6acd817f74df315.svg";
export { ForwardRef as ReactComponent };